'use client';
import DynamicImage from '@/components/DynamicImage';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
// import { AnimatedButton } from './common/AnimatedButton';
// import RegisDialog from './regisDialog';

const Contenttwomobile = () => {
  const line1 =
    'https://osscdn.weiyouzhihui.com/editorVideo/1736414400632/Frame%201312321283%402x.png';
  const line2 =
    'https://osscdn.weiyouzhihui.com/editorVideo/1736414430259/Frame%201312321282%402x.png';
  const items = [
    {
      title: '客户获取难、引流成本高',
      dsc: '获客难，获客渠道有限，用户属于公域平台，二次引流成本高',
      icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736414505965/Frame%20427319427%402x.png',
    },
    {
      title: '触达留存难',
      dsc: '平台客户忠诚度低，互动性差，缺乏有效的营销玩法，触达率低，难留存',
      icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736414565696/Frame%20427319427%402x%20(1).png',
    },
    {
      title: '转化低，复购少',
      dsc: '企业缺乏高效的客户转化方法，传统销售模式失灵，私域客户转化率低',
      icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736414587958/Frame%20427319425%402x.png',
    },
    {
      title: '管理难，效率低',
      dsc: '私域运营门槛高，客户服务效率低，员工离职容易带走客户',
      icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736414587958/Frame%20427319425%402x.png',
    },
  ];
  return (
    <section className="w-full px-[20px]">
      <motion.div
        className="text-center mb-8"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-[18px] mt-[32px] mb-[16px] font-medium text-black/85">
          客户做私域遇到的痛点
        </h2>
        <div className="flex flex-wrap gap-[26px] relative">
          {items.map((item, index) => (
            <div key={index} className="w-[46%] flex flex-col justify-start items-center">
              <DynamicImage src={item.icon} className="w-[40px] h-[40px]"></DynamicImage>
              <p className="text-[14px] text-[rgba(0,0,0,0.85)] mt-[16px] mb-[4px]">{item.title}</p>
              <p className="text-[12px] text-[rgba(0,0,0,0.65)] px-[3px]">{item.dsc}</p>
            </div>
          ))}
          <img
            className="absolute top-[50%] translate-y-[-50%] left-[50%] translate-x-[-50%] w-[80%]"
            src={line1}
            alt=""
          />
          <img
            className="absolute top-[50%] translate-y-[-50%] left-[50%] translate-x-[-50%] h-[80%]"
            src={line2}
            alt=""
          />
        </div>
      </motion.div>
    </section>
  );
};

export default Contenttwomobile;
